import { useEffect, useRef } from 'react';

export interface VideoPreviewProps {
  stream: MediaStream | null;
  mediaBlobUrl: string;
}

const VideoPreview = ({ stream, mediaBlobUrl }: VideoPreviewProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current && stream && stream.active) {
      videoRef.current.srcObject = stream;
    }
    else {
      videoRef.current.srcObject = undefined;
    }
  }, [stream]);

  const isStreamActive = stream?.active;
  return (
    <video
      autoPlay
      playsInline
      controls={false}
      ref={videoRef}
      loop={!isStreamActive}
      src={!isStreamActive ? mediaBlobUrl : undefined}
      style={{
        margin: '0 auto',
        width: '100%',
        height: '400px',
        maxWidth: '100%',
        aspectRatio: '4/5',
        objectFit: 'cover',
        borderRadius: '10px'
      }}
    />
  );
};

export default VideoPreview;
